<template>
  <div>
    <error-page-with-header v-if="!isCallbackRoute"
                            :errorName="errorName"
                            :errorDescription="errorDescription"
                            :logoUrl="logoUrl"
    ></error-page-with-header>
  </div>
</template>

<script>
  import ErrorPageWithHeader from "@/components/ErrorPageWithHeader";
  import logoUrl from "../assets/image/error_pages/404.png";
  export default {
    components: {
      ErrorPageWithHeader
    },
    created(){
      if(this.$route.path==='/callback'){
        this.isCallbackRoute = true;
      }
    },
    data() {
      return {
        isCallbackRoute:false,
        errorName: "Page not found",
        errorDescription:
                "We either couldn't load this page or it doesn't exist anymore. Try again later or check the URL again.",
        logoUrl: logoUrl
      };
    }
  };
</script>







// WEBPACK FOOTER //
// src/components/PageNotFound.vue